import { useState, useEffect } from 'react';
import { api } from '../api';
import Logo from '../components/Logo';

export default function ResetPassword() {
  const [token, setToken]     = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');
  const [success, setSuccess]   = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get('token');
    if (!t) setError('Token inválido. Solicitá un nuevo enlace.');
    else setToken(t);
  }, []);

  const handleReset = async () => {
    if (password.length < 8) { setError('Mínimo 8 caracteres'); return; }
    if (password !== confirm) { setError('Las contraseñas no coinciden'); return; }
    setLoading(true);
    setError('');
    try {
      await api.resetPasswordWithToken(token, password);
      setSuccess(true);
    } catch (e) {
      setError(e.message || 'Error al resetear la contraseña');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center',
                  justifyContent: 'center', background: 'var(--bg)' }}>
      <div style={{ width: 360, padding: 32, border: '1px solid var(--border)',
                    background: 'var(--surface)' }}>
        <Logo size={18} style={{ marginBottom: 8 }} />
        <div style={{ fontFamily: 'var(--mono)', fontSize: 11, color: 'var(--muted)',
                      letterSpacing: 2, marginBottom: 24 }}>NUEVA CONTRASEÑA</div>

        {success ? (
          <div>
            <div style={{ color: 'var(--green)', fontFamily: 'var(--mono)',
                          fontSize: 13, marginBottom: 16 }}>
              ✓ Contraseña actualizada correctamente.
            </div>
            <a href="/" style={{ color: 'var(--accent)', fontFamily: 'var(--mono)',
                                  fontSize: 12 }}>
              Ir al login →
            </a>
          </div>
        ) : (
          <>
            {error && (
              <div style={{ color: 'var(--red)', fontFamily: 'var(--mono)',
                            fontSize: 12, marginBottom: 16,
                            padding: '10px 14px',
                            border: '1px solid var(--red)',
                            background: 'rgba(255,77,109,0.08)' }}>
                {error}
              </div>
            )}
            <input
              type="password"
              placeholder="Nueva contraseña"
              value={password}
              autoComplete="new-password"
              onChange={e => setPassword(e.target.value)}
              style={{ width: '100%', padding: '10px 12px', background: 'var(--bg)',
                       border: '1px solid var(--border)', color: 'var(--text)',
                       fontFamily: 'var(--mono)', fontSize: 13, outline: 'none',
                       boxSizing: 'border-box', marginBottom: 12 }}
            />
            <input
              type="password"
              placeholder="Confirmar contraseña"
              value={confirm}
              autoComplete="new-password"
              onChange={e => setConfirm(e.target.value)}
              style={{ width: '100%', padding: '10px 12px', background: 'var(--bg)',
                       border: '1px solid var(--border)', color: 'var(--text)',
                       fontFamily: 'var(--mono)', fontSize: 13, outline: 'none',
                       boxSizing: 'border-box', marginBottom: 16 }}
            />
            <button
              onClick={handleReset}
              disabled={loading || !token}
              style={{ width: '100%', background: 'var(--accent)', border: 'none',
                       color: 'var(--bg)', padding: '12px 0', fontFamily: 'var(--mono)',
                       fontSize: 12, fontWeight: 700, letterSpacing: 2,
                       cursor: loading ? 'not-allowed' : 'pointer' }}
            >
              {loading ? 'GUARDANDO...' : 'GUARDAR CONTRASEÑA →'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
